<stages-dialog2 #dialog [classes]="[]" (beforeClose)="onBeforeClose()">
	<router-outlet></router-outlet>
</stages-dialog2>
